import abi from './abi.json';
import { Network } from '../../providers/Networks/useNetworks';
import { IContractConfig } from '../types';

export const userProfileConfig: { [network in Network]: IContractConfig } = {
	[Network.MUMBAI_TESTNET]: {
		abi: abi,
		address: '0xC3b207a1838f743A845a6a8050EBE71960dF3AfA',
	},
	[Network.POLYGON_MAINNET]: {
		abi: abi,
		address: '0xcBd16b94F0c9B306d9d5B511378d7a7155E555E1',
	},
};
